import { connector } from "../../common/connector";
import dayjs from "dayjs";

export const defaultItem = {
    id: 0,
    codigo: "",
    fecha_inicio: dayjs().format('YYYY-MM-DD'),
    fecha_fin: "",
    cliente_id: "",
    abogado_titular_id: "",
    abogado_junior_id: "",
    area_id: '',
    tramite_id: '',
    monto_adeudado_tramites: 0,
    monto_adeudado_honorarios: 0,
    monto_adeudado_total: 0,
    monto_cancelado: 0,
    cliente: {
        id: 0,
        nombres: "",
        celular: "",
        direccion: ""
    },
    titular: {
        id: 0,
        user_id: 0,
        nombres: "",
        apellidos: ""
    },
    junior: {

    },
    area: {
        id: 0,
        nombre: ""
    },
    tramite: {

    },
    pasos: [],
    pagos: [],
    documentos: ''
}

export const defaultPaso = {
    id: 0,
    caso_id: 0,
    descripcion: "",
    notificacion: "",
    estado: "PENDIENTE"
}

export const defaultPago = {
    id: 0,
    caso_id: 0,
    codigo: '',
    fecha: dayjs().format('YYYY-MM-DD'),
    monto: 0,
    descripcion: '',
    notificacion: '',
    estado: 'PENDIENTE'
}

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FILL':
            return action.payload;

        case 'ADD':
            return [...state, action.payload];

        case 'UPDATE':
            return state.map(it => {
                if(it.id === action.payload.id) { return action.payload; }
                else { return it; }
            });

        case 'REMOVE':
            return state.filter(it => it.id != action.payload);
        default: return state;
    }
}

export const getItems = (params) => {
    return connector.get('api/casos', { params: params });
}

export const createItem = (data) => {
    return connector.post('api/casos', data);
}

export const updateItem = (data) => {
    return connector.put(`api/casos/${data.id}`, data)
}

export const deleteItem = (id) => {
    return connector.delete(`api/casos/${id}`);
}

export const getResources = () => {
    return connector.get('api/casos/resources');
}

// #region pasos
export const createPaso = (data) => {
    return connector.post('api/caso-pasos', data);
}

export const updatePaso = (data) => {
    return connector.put(`api/caso-pasos/${data.id}`, data);
}

export const deletePaso = (id) => {
    return connector.delete(`api/caso-pasos/${id}`);
}

export const estadoPaso = (id, estado) => {
    return connector.post(`api/caso-pasos/${id}/estado`, { estado: estado });
}

export const changeno = (data) => {
    return connector.post(`api/caso-pasos/changeno`, data);
}

// #endregion pasos

// #region pagos
export const createPago = (data) => {
    return connector.post('api/caso-pagos', data);
}

export const updatePago = (data) => {
    return connector.put(`api/caso-pagos/${data.id}`, data);
}

export const deletePago = (id) => {
    return connector.delete(`api/caso-pagos/${id}`);
}

export const estadoPago = (id, estado) => {
    return connector.post(`api/caso-pagos/${id}/estado`, { estado: estado });
}

// #endregion pagos

// #region documentos
export const upload_documentos = (item, data) => {
    return connector.post(`api/caso-documentos/${item.id}`, data);
}

export const delete_documentos = (item) => {
    return connector.delete(`api/caso-documentos/${item.id}`);
}

// #endregion documentos
